/* eslint-disable */
import {useCallback, useEffect, useMemo, useState} from 'react';
import {Pagination, Spin, Table} from 'antd';
import {observer} from 'mobx-react-lite';
import {useStore} from 'hooks/useStore';
import request from 'utils/request';
import configArchive from './tableArchive.config';
import AlarmDeviationAnalysisModal from '../ActiveAlarms/components/AlarmDeviationAnalysisModal';
import {useTranslation} from 'react-i18next';

import './styles.css';

const ArchiveAlarms = observer(() => {
    const {wellStore, accessStore} = useStore();
    const {t} = useTranslation();

    const [alarmData, setAlarmData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
    });

    const isModalVisible = Boolean(selectedRecord);

    const fetchData = useCallback(async (page = 1, pageSize = 50) => {
        if (!wellStore?.id) return;
        try {
            setIsLoading(true);
            const {data} = await request.get(
                `/alarm/${wellStore.id}/archiveAlarmsData?page=${page}&limit=${pageSize}`
            );

            setAlarmData(data.items);
            setPagination(prev => ({
                ...prev,
                current: page,
                pageSize,
                total: data.total,
            }));
        } catch (error) {
            console.error('Error fetching alarm data:', error);
            setAlarmData([]);
        } finally {
            setIsLoading(false);
        }
    }, [wellStore.id]);

    useEffect(() => {
        fetchData(pagination.current, pagination.pageSize);
    }, [fetchData]);

    const handlePageChange = useCallback((page, pageSize) => {
        fetchData(page, pageSize);
    }, [fetchData]);

    const columns = useMemo(
        () => configArchive({t, accessStore, setSelectedRecord}),
        [t, accessStore]
    );

    const closeModal = useCallback(() => setSelectedRecord(null), []);

    return (
        <div className="alarm-content">
            <Spin spinning={isLoading} size="large">
                <Table
                    columns={columns}
                    dataSource={alarmData}
                    rowKey="id"
                    pagination={false}
                    virtual
                    sticky
                    className="alerts-table custom-borders"
                    rowClassName="alerts-row"
                />

                <div className="pagination-wrapper">
                    <Pagination
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        showSizeChanger
                        pageSizeOptions={['20', '50', '100', '200']}
                        onChange={handlePageChange}
                        locale={{items_per_page: t("onPage")}}
                    />
                </div>
            </Spin>

            <AlarmDeviationAnalysisModal
                visible={isModalVisible}
                closeModal={closeModal}
                data={selectedRecord}
                isAlarmArchived={true}
            />
        </div>
    );
});

export default ArchiveAlarms;
